// src/inject.js
var inject_default = () => {
  var bridge = {
    default: void 0,
    call: function(b, a, c) {
      var e = "";
      typeof a === "function" && (c = a, a = {});
      a = { data: void 0 === a ? null : a };
      if (typeof c === "function") {
        var g = "dscb" + window.dscb++;
        window[g] = c;
        a._dscbstub = g;
      }
      a = JSON.stringify(a);
      if (window._dsbridge)
        e = _dsbridge.call(b, a);
      else if (window._dswk || navigator.userAgent.indexOf("_dsbridge") != -1)
        e = prompt("_dsbridge=" + b, a);
      return JSON.parse(e || "{}").data;
    },
    register: function(b, a, c) {
      c = c ? window._dsaf : window._dsf;
      window._dsInit || (window._dsInit = true, setTimeout(function() {
        bridge.call("_dsb.dsinit");
      }, 0));
      typeof a === "object" ? c._obs[b] = a : c[b] = a;
    },
    registerAsyn: function(b, a) {
      this.register(b, a, true);
    },
    hasNativeMethod: function(b, a) {
      return this.call("_dsb.hasNativeMethod", { name: b, type: a || "all" });
    },
    disableJavascriptDialogBlock: function(b) {
      this.call("_dsb.disableJavascriptDialogBlock", { disable: false !== b });
    }
  };
  !function() {
    if (!window._dsf) {
      var b = {
        _dsf: { _obs: {} },
        _dsaf: { _obs: {} },
        dscb: 0,
        dsBridge: bridge,
        close: function() {
          bridge.call("_dsb.closePage");
        },
        _handleMessageFromNative: function(a2) {
          var e = JSON.parse(a2.data);
          var b2 = { id: a2.callbackId, complete: true };
          var c = this._dsf[a2.method];
          var d = this._dsaf[a2.method];
          var h = function(a3, c2) {
            b2.data = a3.apply(c2, e);
            bridge.call("_dsb.returnValue", b2);
          };
          var k = function(a3, c2) {
            e.push(function(a4, c3) {
              b2.data = a4;
              b2.complete = false !== c3;
              bridge.call("_dsb.returnValue", b2);
            });
            a3.apply(c2, e);
          };
          if (c)
            h(c, this._dsf);
          else if (d)
            k(d, this._dsaf);
          else if (c = a2.method.split("."), !(c.length < 2)) {
            a2 = c.pop();
            var c = c.join(".");
            var d = this._dsf._obs;
            var d = d[c] || {};
            var f = d[a2];
            f && typeof f === "function" ? h(f, d) : (d = this._dsaf._obs, d = d[c] || {}, (f = d[a2]) && typeof f === "function" && k(f, d));
          }
        }
      };
      var a;
      for (a in b)
        window[a] = b[a];
      bridge.register("_hasJavascriptMethod", function(a2, b2) {
        b2 = a2.split(".");
        if (b2.length < 2)
          return !(!_dsf[b2] && !_dsaf[b2]);
        a2 = b2.pop();
        b2 = b2.join(".");
        return (b2 = _dsf._obs[b2] || _dsaf._obs[b2]) && !!b2[a2];
      });
    }
  }();
};

// src/injectFlutter.js
var injectFlutter_default = () => {
  (function() {
    function JSBridge() {
      var _handlers = {};
      var _callbacks = {};
      var _promises = {};
      var _id = 0;
      var _debug = false;
      var _channel = ["flutter"];
      function _log() {
        if (_debug) {
          var args = Array.prototype.slice.call(arguments);
          console.log.apply(null, args);
        }
      }
      function _isIframeChannel() {
        return _channel.indexOf("iframe") > -1;
      }
      function _isFlutterChannel() {
        return _channel.indexOf("flutter") > -1;
      }
      function _isReactNativeChannel() {
        return _channel.indexOf("reactnative") > -1;
      }
      function _init(config) {
        if (config) {
          if (config.debug) {
            _debug = !!config.debug;
          }
          if (config.channel && Object.prototype.toString.apply(config.channel) === "[object Array]") {
            _channel = config.channel;
            if (_isIframeChannel()) {
              window.addEventListener("message", (event) => {
                window.eval(event.data);
              });
            }
          }
        }
        _registerHandler("#evalJavaScript#", function(data, success, fail) {
          try {
            success(Function('"use strict";return (' + data.toString() + ")")());
          } catch (error) {
            _log(error);
            fail(error.toSring());
          }
        });
        _callHandler("#jsbridgeReady#", {
          data: true,
          success: function(data) {
            _log("[#jsbridgeReady#] success response: " + data);
          },
          fail: function(err) {
            _log("[#jsbridgeReady#] fail response: " + err);
          }
        });
      }
      function _registerHandler(handlerName, handler) {
        _handlers[handlerName] = handler;
      }
      function _unregisterHandler(handlerName) {
        if (!_handlers[handlerName]) {
          return;
        }
        delete _handlers[handlerName];
      }
      function _callHandler(handlerName, payload) {
        return _receiverCall(handlerName, payload);
      }
      function _onMessageReceived(messageString) {
        var decodeString = decodeURIComponent(messageString);
        var jsonData = JSON.parse(decodeString);
        _log("[WebViewJSBridge receiveMessage]: ", jsonData);
        var message = jsonData;
        if (message.type === "request") {
          _senderCall(message);
        }
        if (message.type === "response") {
          _receiverCallResponse(message);
        }
      }
      function _postMessage(jsonData) {
        _log("[WebViewJSBridge postMessage]: ", jsonData);
        var jsonString = JSON.stringify(jsonData);
        var encodeString = encodeURIComponent(jsonString);
        if (_isIframeChannel()) {
          if (self != top) {
            window.parent.postMessage(encodeString, "*");
          }
        }
        if (_isFlutterChannel()) {
          window.FlutterWebView && window.FlutterWebView.postMessage(encodeString);
        }
        if (_isReactNativeChannel()) {
          window.ReactNativeWebView && window.ReactNativeWebView.postMessage(encodeString);
        }
      }
      function _receiverCall(handlerName, payload) {
        if (!handlerName) {
          throw Error("WebViewJSBridge: handler name can not be null!!!");
        }
        var message = {
          id: _id++,
          type: "request",
          resolved: false,
          rejected: false
        };
        message.action = handlerName;
        if (payload) {
          if (payload.data) {
            message.data = payload.data;
          }
          if (payload.success) {
            if (!_callbacks[message.id]) {
              _callbacks[message.id] = {};
            }
            _callbacks[message.id].success = payload.success;
          }
          if (payload.fail) {
            if (!_callbacks[message.id]) {
              _callbacks[message.id] = {};
            }
            _callbacks[message.id].fail = payload.fail;
          }
        }
        _postMessage(message);
        if (!_callbacks[message.id]) {
          if (/native code/.test(Promise.toString()) && typeof Promise !== "undefined") {
            return new Promise(
              (resolve, reject) => _promises[message.id] = { resolve, reject }
            );
          }
        }
      }
      function _receiverCallResponse(message) {
        var id = message.id;
        var data = message.data;
        var isResolved = message.resolved;
        var isRejected = message.rejected;
        if (_callbacks[id]) {
          if (isResolved) {
            _callbacks[id].success && _callbacks[id].success(data);
          }
          if (isRejected) {
            _callbacks[id].fail && _callbacks[id].fail(data);
          }
          delete _callbacks[id];
        }
        if (_promises[id]) {
          if (isResolved) {
            _promises[id].resolve(data);
          }
          if (isRejected) {
            _promises[id].reject(data);
          }
          delete _promises[id];
        }
      }
      function _senderCall(message) {
        function _successResponse(data) {
          message = {
            action: message.action,
            data,
            id: message.id,
            type: "response",
            resolved: true,
            rejected: false
          };
          _senderCallResponse(message);
        }
        function _failResponse(err) {
          message = {
            action: message.action,
            data: err,
            id: message.id,
            type: "response",
            resolved: false,
            rejected: true
          };
          _senderCallResponse(message);
        }
        var handlerName = message.action;
        if (handlerName in _handlers) {
          var handler = _handlers[handlerName];
          var promise = handler(
            message.data,
            function(data) {
              _successResponse(data);
            },
            function(err) {
              _failResponse(err);
            }
          );
          if (Object.prototype.toString.call(promise) == "[object Promise]") {
            promise.then(function(data) {
              _successResponse(data);
            }).catch(function(err) {
              _failResponse(err.toString());
            });
          }
        } else {
          _failResponse(`handler name -> ${handlerName} can't find!!!`);
        }
      }
      function _senderCallResponse(message) {
        _postMessage(message);
      }
      return {
        init: _init,
        registerHandler: _registerHandler,
        unregisterHandler: _unregisterHandler,
        callHandler: _callHandler,
        onMessageReceived: function(messageString) {
          setTimeout(function() {
            _onMessageReceived(messageString);
          }, 0);
        }
      };
    }
    if (window.WebViewJSBridge) {
      return;
    }
    window.WebViewJSBridge = new JSBridge();
    setTimeout(() => {
      console.log("---Flutter JS Bridge Ready---");
      window.WebViewJSBridge.init();
      var doc = document;
      var readyEvent = doc.createEvent("Event");
      var jobs = window.WVJBCallbacks || [];
      readyEvent.initEvent("WebViewJSBridgeReady", true, false);
      readyEvent.bridge = window.WebViewJSBridge;
      delete window.WVJBCallbacks;
      for (var i = 0; i < jobs.length; i++) {
        var job = jobs[i];
        job(window.WebViewJSBridge);
      }
      doc.dispatchEvent(readyEvent);
    }, 0);
  })();
};

// src/api.ts
function callBridge(action, params, { success, fail }) {
  if (!window.dsBridge && !window.WebViewJSBridge)
    return false;
  if (window.WebViewJSBridge) {
    return window.WebViewJSBridge.callHandler(action, {
      data: JSON.stringify(params),
      success,
      fail
    });
  }
  return window.dsBridge.call("callAsyn", { action, ...params }, function(v) {
    if (v) {
      success && success(v);
    } else {
      fail && fail(v);
    }
  });
}
function init() {
  inject_default();
}
function initFlutter() {
  injectFlutter_default();
}
function bindWechatAccount(arg) {
  const { success, fail } = arg;
  return callBridge("bindWechatAccount", {}, { success, fail });
}
function pickMedia(opts) {
  const { success, fail, ...params } = opts;
  return callBridge("pickMedia", params, {
    success: (res) => {
      try {
        success && success(JSON.parse(res));
      } catch (err) {
        fail && fail(err);
      }
    },
    fail
  });
}
function getAppPkgId() {
  const userAgent = navigator.userAgent.toLowerCase();
  const regex = /echoapppackage\/(\d+)/;
  const match = userAgent.match(regex);
  return match ? match[1] : null;
}
function isApp() {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf("kuril-ios") !== -1) {
    return "iOS";
  }
  if (userAgent.indexOf("kuril-android") !== -1) {
    return "Android";
  }
  return false;
}
function login(arg = {}) {
  const { success, fail } = arg;
  callBridge(
    "navigateTo",
    {
      path: "https://qiandao.cn/login"
    },
    { success, fail }
  );
}
function openUrl(url) {
  const path = `/webview?url=${encodeURIComponent(url)}`;
  navigateTo({ url: path });
}
function navigateTo(arg = {
  url: ""
}, ori = false) {
  const { url, success, fail } = arg;
  if (ori) {
    window.location.href = url;
  } else if (window.WebViewJSBridge) {
    callBridge("navigateTo", arg, { success, fail });
  } else {
    callBridge(
      "navigateTo",
      {
        path: "https://qiandao.cn" + url
      },
      { success, fail }
    );
  }
}
function getUserInfo(arg = {}, ori = false) {
  const { success, fail } = arg;
  if (window.WebViewJSBridge) {
    callBridge("getUserInfo", arg, { success, fail });
  }
}
function navigateToUrl(arg = {
  url: ""
}, ori = false) {
  const { url, success, fail } = arg;
  if (ori) {
    window.location.href = url;
  } else {
    callBridge(
      "navigateTo",
      {
        path: url
      },
      { success, fail }
    );
  }
}
function redirectToUrl(arg = { url: "" }) {
  const { url, animated = true, success, fail } = arg;
  callBridge(
    "redirectTo",
    {
      path: url,
      animated
    },
    { success, fail }
  );
}
function redirectTo(arg = { url: "" }) {
  const { url, animated = true, success, fail } = arg;
  callBridge(
    "redirectTo",
    {
      path: "https://qiandao.cn" + url,
      animated
    },
    { success, fail }
  );
}
function switchTab(arg = {}) {
  const { url, success, fail } = arg;
  callBridge(
    "switchTab",
    {
      path: "https://qiandao.cn" + url
    },
    { success, fail }
  );
}
function navigateBack(arg = {}, ori = false) {
  if (ori === true) {
    window.history.back();
  } else {
    const { delta = 1, success, fail } = arg;
    callBridge(
      "navigateBack",
      {
        delta
      },
      { success, fail }
    );
  }
}
function navigateToMiniProgram(arg = {}) {
  const { appId, path, success, fail } = arg;
  callBridge(
    "navigateToMiniProgram",
    {
      appId: appId || "wxaf7362726f135b5c",
      path
    },
    { success, fail }
  );
}
function setClipboardData(arg = {}) {
  const { data, success, fail } = arg;
  callBridge(
    "setClipboardData",
    {
      data
    },
    { success, fail }
  );
}
function saveImageToPhotosAlbum(arg = {}) {
  const { filePath, success, fail } = arg;
  callBridge(
    "saveImageToPhotosAlbum",
    {
      filePath
    },
    { success, fail }
  );
}
function shareUrl(arg = {}) {
  const { url, imageUrl = "", title = "", content = "", success, fail } = arg;
  if (window.WebViewJSBridge) {
    callBridge(
      "shareUrl",
      {
        url,
        imageUrl,
        title,
        content
      },
      { success, fail }
    );
  } else {
    callBridge(
      "shareUrl",
      {
        url,
        imageUrl,
        title
      },
      { success, fail }
    );
  }
}
function wechatPay(arg = {}) {
  const {
    success,
    fail,
    nonceStr,
    prepayId,
    timeStamp,
    sign,
    signType,
    partnerId
  } = arg;
  callBridge(
    "wechatPay",
    {
      nonceStr,
      prepayId,
      timeStamp,
      sign,
      signType,
      partnerId,
      package: arg.package
    },
    { success, fail }
  );
}
function aliPay(arg = {}) {
  const { success, fail, data } = arg;
  callBridge(
    "aliPay",
    {
      data
    },
    { success, fail }
  );
}
async function isWechatInstalled() {
  if (!isApp())
    return false;
  return new Promise((resolve, reject) => {
    callBridge(
      "isWechatInstalled",
      {},
      {
        success: (res) => {
          if (res === "false" || !res) {
            resolve(false);
          } else if (res === "true" || res) {
            resolve(true);
          }
        },
        fail: (err) => {
          reject(err);
        }
      }
    );
  });
}
async function isAlipayInstalled() {
  if (!isApp())
    return false;
  return new Promise((resolve, reject) => {
    callBridge(
      "isAlipayInstalled",
      {},
      {
        success: (res) => {
          if (res === "false" || !res) {
            resolve(false);
          } else if (res === "true" || res) {
            resolve(true);
          }
        },
        fail: (err) => {
          reject(err);
        }
      }
    );
  });
}
function token(tokenKey, arg = {}) {
  const { success, fail } = arg;
  if (isApp()) {
    return callBridge("h5Token", {}, { success, fail });
  } else {
    success == null ? void 0 : success(window.localStorage.getItem(tokenKey));
  }
}
function tokenSync(tokenKey) {
  if (window.WebViewJSBridge) {
    const userAgent = navigator.userAgent;
    return userAgent.replace(/linjie/, "");
  } else if (isApp()) {
    const userAgent = navigator.userAgent;
    const userAgentArr = userAgent.split(/[ ]+/);
    for (let i = 0; i < userAgentArr.length; ++i) {
      const currentPart = userAgentArr[i];
      if (currentPart.indexOf("kuril-ios") !== -1) {
        return currentPart.replace(/kuril-ios/, "");
      } else if (currentPart.indexOf("kuril-android") !== -1) {
        return currentPart.replace(/kuril-android/, "");
      }
    }
  }
  return window.localStorage.getItem(tokenKey);
}
function showShareMenu(arg = {}) {
  const { withShareTicket = false, success, fail } = arg;
  return callBridge(
    "showShareMenu",
    {
      withShareTicket
    },
    {
      success,
      fail
    }
  );
}
function hideShareMenu(arg = {}) {
  const { success, fail } = arg;
  return callBridge(
    "hideShareMenu",
    {},
    {
      success,
      fail
    }
  );
}
function openSetting(arg = {}) {
  const { success, fail } = arg;
  return callBridge("openSetting", {}, { success, fail });
}
function getSetting(arg = {}) {
  const { success, fail } = arg;
  return callBridge(
    "getSetting",
    {},
    {
      success: (value) => {
        success == null ? void 0 : success({ authSetting: JSON.parse(value) });
      },
      fail
    }
  );
}
function authorize(arg = {}) {
  const { scope, success, fail } = arg;
  return callBridge("authorize", { scope }, { success, fail });
}
function onShareAppMessage(arg = {}) {
  const { title, path, imageUrl, success, fail } = arg;
  return callBridge(
    "onShareAppMessage",
    { title, path, imageUrl },
    { success, fail }
  );
}
function shareMiniApp(arg = {}) {
  const {
    title = "",
    path = "",
    imageUrl = "",
    miniAppId = "",
    success,
    fail
  } = arg;
  return callBridge(
    "shareMiniApp",
    { title, path, imageUrl, miniAppId },
    { success, fail }
  );
}
function showAppShareButton(arg = {}) {
  const { title, path, imageUrl, success, fail } = arg;
  return callBridge(
    "showAppShareButton",
    { title, path, imageUrl },
    { success, fail }
  );
}
function previewImage(arg = {}) {
  const { urls, current, success, fail } = arg;
  return callBridge(
    "previewImage",
    { urls, current },
    {
      success,
      fail
    }
  );
}
function shareMiniAppAndCopyLink(arg = {}) {
  const { title, path, imageUrl, miniAppId, text, success, fail } = arg;
  return callBridge(
    "shareMiniAppAndCopyLink",
    { title, path, imageUrl, miniAppId, text },
    { success, fail }
  );
}
function getAppVersion(arg = {}) {
  const { success, fail } = arg;
  return callBridge("getAppVersion", {}, { success, fail });
}
function getAppVersionSync() {
  const exec = /Kuril\/(\d+\.\d+\.\d+)/.exec(navigator.userAgent);
  if (exec) {
    const version = exec[1];
    return version || null;
  }
  return null;
}
if (typeof window !== "undefined" && window.dsBridge) {
  window.dsBridge.registerAsyn(
    "blobImageToBase64",
    (path, responseCallback) => {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", path, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response;
          const reader = new window.FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = function() {
            responseCallback(reader.result);
          };
        } else {
          responseCallback("");
        }
      };
      xhr.send();
    }
  );
}
var api_default = {
  init,
  initFlutter,
  isApp,
  getAppPkgId,
  token,
  tokenSync,
  getUserInfo,
  login,
  openUrl,
  navigateTo,
  navigateToUrl,
  redirectToUrl,
  redirectTo,
  switchTab,
  navigateBack,
  navigateToMiniProgram,
  setClipboardData,
  saveImageToPhotosAlbum,
  shareUrl,
  wechatPay,
  aliPay,
  isWechatInstalled,
  isAlipayInstalled,
  showShareMenu,
  hideShareMenu,
  openSetting,
  getSetting,
  authorize,
  onShareAppMessage,
  shareMiniApp,
  showAppShareButton,
  shareMiniAppAndCopyLink,
  getAppVersion,
  getAppVersionSync,
  previewImage,
  pickMedia,
  bindWechatAccount
};

// src/index.ts
var src_default = api_default;
export {
  src_default as default
};
